module.exports = __webpack_public_path__ + "img/culture-2.e291ddb3.jpg";